import React, { Component } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { MultiSelectProps } from 'primereact/multiselect';
import LanguageUtil from '../../util/LanguageUtil';

const MAX_VISIBLE_SELECTED_ITEMS = 8;

class CustomMultiSelect extends Component<Props> {
  public render() {
    const { items, selectedItems, label, ...rest } = this.props;

    const itemTemplate = (option: any) => {
      if (option) {
        return (
          <div data-testid={`select-item-${option.value}`} className='text-primary gro !h-[16px] flex items-center text-2xs'>
            <div>{option.label}</div>
          </div>
        );
      }
    };

    const panelFooterTemplate = () => {
      const length = selectedItems ? selectedItems.length : 0;
      return (
        <div className='py-2 px-3'>
          <b>{length}</b> item{length > 1 ? 's' : ''} selected.
        </div>
      );
    };

    const selectedRolesTemplate = (option: any) => {
      if (!option) {
        return;
      }
      const index = selectedItems ? selectedItems.indexOf(option) : -1;
      if (index >= MAX_VISIBLE_SELECTED_ITEMS) {
        return null;
      }
      const hiddenCount = selectedItems ? selectedItems.length - MAX_VISIBLE_SELECTED_ITEMS : 0;
      const isLastVisible = index === MAX_VISIBLE_SELECTED_ITEMS - 1 && hiddenCount > 0;
      return (
        <React.Fragment>
          <div className={'inline-flex m-0.5 h-[20px] py-2 px-2 text-2xs rounded items-center bg-secondary  text-f-purple '}>
            <p className={'flex items-center justify-center'}>{option}</p>
          </div>
          {isLastVisible && (
            <div className={'inline-flex items-center m-0.5 h-[20px] px-1 text-2xs text-f-black2'}>
              <p>{`+${hiddenCount}`}</p>
            </div>
          )}
        </React.Fragment>
      );
    };

    return (
      <div className={'relative group w-full min-w-0'}>
        <MultiSelect
          value={selectedItems}
          options={items}
          filter
          filterPlaceholder={LanguageUtil.get({ id: 'common.input.placeholder.filter', defaultMessage: 'Filter' })}
          className={'!h-[34px] !max-w-full flex items-center !text-2xs !bg-white !border-f-black-5 !overflow-hidden'}
          itemTemplate={itemTemplate}
          selectedItemTemplate={selectedRolesTemplate}
          panelFooterTemplate={panelFooterTemplate}
          {...rest}
        />
      </div>
    );
  }
}

interface Props extends MultiSelectProps {
  items: MultiSelectItems[];
  selectedItems: any[];
  label: string;
}

interface MultiSelectItems {
  label: string;
  value: string;
}

export default CustomMultiSelect;
